import { MenuItem, MenuUrls, MenuUrlsLv2 } from './topNav.types';

export const getChildUrls = (items: MenuItem[] = [], initUrls: string[] = []): string[] => {
  return items.reduce((urls, item) => {
    const itemUrls = getChildUrls(item.items, urls);
    const childUrls = [...itemUrls, ...(item.childUrls || [])];
    return item.url ? [item.url, ...childUrls] : childUrls;
  }, initUrls);
};

export const getAllUrls = (menuItems: MenuItem[]) => {
  const urls: MenuUrls = {};

  menuItems.forEach((menu) => {
    const initialValue = { '': menu.url ? [menu.url] : [] };
    if (menu.items) {
      urls[menu.key] = menu.items.reduce((urls, item) => {
        const childUrls = item.childUrls || [];
        const initUrls = item.url ? [item.url, ...childUrls] : childUrls;
        return {
          ...urls,
          [item.key]: getChildUrls(item.items, initUrls),
        };
      }, initialValue as MenuUrlsLv2);
    }
  });

  return urls;
};
